<template>
    <section class="bg-white">
        <div class="bg-logo text-center mb-2" :style="`background-color:${bgColor[$app.nome_divulgacao]};`">
            <img
                v-if="$url.module == 'contabilidade'"
                class="logo"
                :src="logoContabilidade[$app.nome_divulgacao].src"
                :alt="logoContabilidade[$app.nome_divulgacao].alt"
            />
            <img v-else class="logo" :src="logo[$app.nome_divulgacao].src" :alt="logo[$app.nome_divulgacao].alt" />
        </div>
        <b-container fluid>
            <b-row class="justify-content-md-center">
                <b-col sm="12" md="10" lg="8" class="my-4">
                    <!-- <h4 v-if="$url.module == 'contabilidade'" class="text-center text-uppercase mb-2">Cadastre sua contabilidade</h4> -->
                    <h4 v-if="$url.module == 'parceiro' && $app.nome_divulgacao == 'GestãoClick'" class="text-center text-uppercase mb-2">Cadastro de parceiro</h4>

                    <b-form @submit.prevent="cadastrar">
                        <div>
                            <dados-gerais :data="data" />
                            <endereco :data="data" />
                            <acesso :data="data" />
                        </div>

                        <div class="footer text-center mt-3">
                            <b-button
                                type="submit"
                                class="btn btn-success btn-lg btn-block my-3 bt-cadastro"
                                :style="`background-color:${bgColor[$app.nome_divulgacao]}; border-color:${bgColor[$app.nome_divulgacao]};`"
                            >
                                Cadastrar
                            </b-button>
                            <div class="mb-2">
                                Clicando no botão acima você concorda com nossos <a style="color: #000" :href="linkTermos[$app.nome_divulgacao]" target="_blank"><b>termos de uso</b></a>
                            </div>
                            <a href="#" @click.prevent="redirParaLogin" class="small">Já tem uma conta? <b>Acessar o sistema</b></a>
                        </div>
                    </b-form>
                    <div class="text-center follow-us" v-if="$app.youtube || $app.facebook || $app.instagram || $app.twitter || $app.linkedin">
                        <span>Siga-nos nas redes sociais</span>
                        <a
                            v-for="rede in redesSociais"
                            v-show="rede.habilitado"
                            :key="rede.nome"
                            :href="rede.link"
                            target="_blank"
                            class="btn btn-circle mx-1"
                            :class="rede.classe"
                        >
                            <img :src="`/img/${rede.image}`" :alt="rede.nome" />
                        </a>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>
<script>
import '@/shared/plugins/recaptcha'
import '@/shared/common/directives/mascaras'
import DadosGerais from './DadosGerais'
import Endereco from './Endereco'
import Acesso from './Acesso'
import { onFocusField } from '@/shared/plugins/vee-validate/utils'
import { mapActions } from 'vuex'
export default {
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        DadosGerais,
        Endereco,
        Acesso
    },
    data() {
        return {
            data: {
                Usuario: {},
                Empresa: {
                    tipo: 'C',
                    usuario_id: 1,
                    dominio_id: 3
                },
                Loja: {
                    tipo_pessoa: 'PJ',
                    estado: '',
                    cidade_id: ''
                }
            },
            redesSociais: [
                {
                    nome: 'YoutTube',
                    classe: '',
                    image: 'svg/youtube.svg',
                    link: this.$app.youtube,
                    habilitado: this.$app.youtube ? true : false
                },
                {
                    nome: 'Facebook',
                    classe: '',
                    image: 'svg/facebook.svg',
                    link: this.$app.facebook,
                    habilitado: this.$app.facebook ? true : false
                },
                {
                    nome: 'Instagram',
                    classe: '',
                    image: 'svg/instagram.svg',
                    link: this.$app.instagram,
                    habilitado: this.$app.instagram ? true : false
                },
                {
                    nome: 'Linkedin',
                    classe: '',
                    image: 'svg/linkedin.svg',
                    link: this.$app.linkedin,
                    habilitado: this.$app.linkedin ? true : false
                }
            ],
            logo: {
                GestãoClick: { src: '/img/logo-gestao-branco.png', alt: 'Logo GestãoClick' },
                ClickNotas: { src: '/img/logo-click-notas-parceiros-branco.png', alt: 'Logo ClickNotas' }
            },
            logoContabilidade: {
                GestãoClick: { src: '/img/logo-gestao-contabilidade-branco.png', alt: 'Logo GestãoClick' },
                ClickNotas: { src: '/img/logo-click-notas-contabilidade-branco.png', alt: 'Logo ClickNotas' }
            },
            linkTermos: {
                GestãoClick: 'https://gestaoclick.com.br/termos-de-revenda/',
                ClickNotas: 'https://clicknotas.com.br/termos-parceiro/'
            },
            bgColor: {
                GestãoClick: '#091d33',
                ClickNotas: '#0f2a71'
            }
        }
    },
    mounted() {
        this.carrega()
    },
    methods: {
        ...mapActions('usuarios', {
            xLogin: 'login'
        }),
        async carrega() {
            if (!this.$route.query.clienteContador) {
                return false
            }
            const retorno = await this.$api.get(this.$route.fullPath)
            if (retorno.status == 'error') {
                this.$notify.error(retorno.message)
                this.$router.push(this.$urlBase + '/')
            }
        },
        async cadastrar() {
            const valido = await this.$validator.validateAll()
            if (!valido) {
                onFocusField(this)
                return
            }
            this.$loading.show()
            this.data['g-recaptcha-response'] = await this.$recaptcha('login')
            const retorno = await this.$api.cPost(this.$route.fullPath, this.data)
            if (retorno.status == 'success') {
                const login = await this.login({
                    Usuario: {
                        email: this.data.Usuario.email,
                        senha: this.data.Usuario.senha
                    }
                })
                if (login.status == 'success') {
                    // tempo necessário para salvar o token no navegador
                    setTimeout(() => {
                        location.href = this.$urlBase + '/inicio?primeiroacesso=true'
                    }, 1500)
                }
            } else {
                this.$dialog.error(retorno.message)
                this.$loading.hide()
            }
        },
        async login(dados) {
            const recaptcha = await this.$recaptcha('login')
            dados['g-recaptcha-response'] = recaptcha
            const login = await this.xLogin(dados)
            if (login.status == 'error') {
                this.$loading.hide()
                this.$dialog.error(login.message)
            }
            return login
        },
        redirParaLogin() {
            const module = String(this.$url.module).trim()
            this.$router.push(module ? `/${module}/login` : '/login')
        }
    }
}
</script>
<style scoped>
.bg-logo {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.logo {
    max-height: 45px !important;
}
a.small {
    color: #0c1b25;
    font-size: 17px;
}
.box-shadow {
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
}

.bt-cadastro {
    width: 100%;
    border-radius: 5px;
    font-weight: 600;
    padding: 7px;
}

.follow-us span {
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: bold;
}

a.btn.btn-circle {
    width: 32px;
    height: 32px;
    border: none;
    box-shadow: none;
}

@media (max-width: 768px) {
    .bt-cadastro {
        font-size: 16px;
        padding: 10px;
    }
}

@media (min-width: 768px) and (max-width: 1200px) {
    .bt-cadastro {
        font-size: 18px;
    }
}
</style>
